// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__hg8Vf","itemTitle":"ClientEmergencyInfo_itemTitle__3Dp5_","itemText":"ClientEmergencyInfo_itemText__3gFQA"};